import { currentPage } from '@cms/utils/src/tag'

export const getPageType = () => {
  if (typeof window === 'undefined') return

  const {
    isHomePage,
    isExamShowcasePage,
    isVaccineShowcasePage,
    isExamDetailPage,
    isVaccineDetailPage,
    isBlogHomePage,
    isBlogArticlePage,
    isUnitShowcasePage,
    isUnitDetailPage,
    isInsurancePage,
  } = currentPage()

  let pageType

  if (isHomePage) {
    pageType = 'Home'
  }

  if (isExamShowcasePage || isVaccineShowcasePage) {
    pageType = 'Vitrine'
  }

  if (isExamDetailPage || isVaccineDetailPage) {
    pageType = 'Página do Produto'
  }

  if (isBlogHomePage || isBlogArticlePage) {
    pageType = 'Blog'
  }

  if (isUnitShowcasePage || isUnitDetailPage) {
    pageType = 'Unidades'
  }

  if (isInsurancePage) {
    pageType = 'Convênios'
  }

  return pageType || 'Página Básica'
}

export const pushToDataLayerOnModalOpenning = ({ buttonLabel, origin }) => {
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []

  const { isVaccineShowcasePage, isVaccineDetailPage } = currentPage()

  window.dataLayer.push({
    event: 'menu_interaction',
    context: {
      button_label: buttonLabel,
      origin: origin || getPageType(),
    },
  })

  window.dataLayer.push({
    event: 'funnel_step',
    funnel: {
      name:
        isVaccineShowcasePage || isVaccineDetailPage
          ? 'Agendamento de Vacinas'
          : 'Agendamento de Exames',
      current_step:
        isVaccineShowcasePage || isVaccineDetailPage
          ? 'Modal Agendamento Vacina'
          : 'Modal Agendamento Exame',
      origin: getPageType(),
    },
  })
}
